/**
 * REUSABLE: The logic to replace ® with <sup>®</sup>
 * @param {Node} textNode - A text node containing the symbol
 */
function scanAndFixSuperscriptIcon() {
  function replaceInTextNode(textNode) {
    // 1. Safety check: avoid processing inside <script>, <style>, or already wrapped <sup>
    if (
      !textNode.nodeValue.includes("®") ||
      !textNode.parentNode ||
      ["SCRIPT", "STYLE", "SUP", "TEXTAREA", "INPUT"].includes(
        textNode.parentNode.tagName,
      )
    ) {
      return;
    }

    const fragment = document.createDocumentFragment();
    const parts = textNode.nodeValue.split("®");

    parts.forEach((part, index) => {
      if (part) fragment.appendChild(document.createTextNode(part));

      if (index < parts.length - 1) {
        const sup = document.createElement("sup");
        sup.textContent = "®";
        sup.className = "styled-reg"; // Add your CSS class here
        fragment.appendChild(sup);
      }
    });

    textNode.parentNode.replaceChild(fragment, textNode);
  }

  /**
   * TRAVERSAL: Finds text nodes within a specific element (or document)
   * @param {Node} rootNode - The element to search inside
   */
  function scanAndFix(rootNode) {
    const walker = document.createTreeWalker(
      rootNode,
      NodeFilter.SHOW_TEXT,
      null,
      false,
    );

    let node;
    const nodesToFix = [];

    while ((node = walker.nextNode())) {
      if (node.nodeValue.includes("®")) {
        nodesToFix.push(node);
      }
    }

    // We loop separately to avoid modifying the DOM while walking it
    nodesToFix.forEach(replaceInTextNode);
  }

  // ---------------------------------------------------------
  // STEP 1: Fix existing content immediately
  // ---------------------------------------------------------
  scanAndFix(document.body);

  // ---------------------------------------------------------
  // STEP 2: Watch for NEW content (AJAX, Modals, SPAs)
  // ---------------------------------------------------------
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((addedNode) => {
        // If a Text Node was added directly
        if (addedNode.nodeType === Node.TEXT_NODE) {
          replaceInTextNode(addedNode);
        }
        // If an Element (div, p, etc.) was added, scan inside it
        else if (addedNode.nodeType === Node.ELEMENT_NODE) {
          scanAndFix(addedNode);
        }
      });
    });
  });

  // Start observing the document body for changes
  observer.observe(document.body, {
    childList: true, // Watch for direct children changes
    subtree: true, // Watch all descendants (deep watch)
  });
}

scanAndFixSuperscriptIcon();
